module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.2-91.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.1-rc.2.md
// module id = 509
// module chunks = 324